const BUSINESS_TYPES = [
  {
    label: "Landbúnaðarsali / Bændabúð",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Dýraathvarf / Góðgerðarsamtök",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Uppeldisstöð",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Nautakjötsframleiðandi",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Kjúklingar", value: "Broilers", id: "broilers" },
  {
    label: "Kaupendahópur",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Kálfaframleiðsla",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Kálfabúgarður/Framkvæmdaraðili",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Nautakaupandi", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Samningsræktandi",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Samvinnufélag", value: "Cooperative", id: "cooperative" },
  {
    label: "Aðalskrifstofa",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Kúa/kálfastarfsemi",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Mjólkurframleiðsla",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Dreifingaraðili / Umboðsmaður",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Fóðurverksmiðja", value: "Feed Mill", id: "feed_mill" },
  { label: "Fóðrunargarður", value: "Feedyard", id: "feedyard" },
  {
    label: "Ræktandi/Ræktunarbú",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Varpstöð", value: "Hatchery", id: "hatchery" },
  {
    label: "Kvígaframleiðsla",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Varphænsnasamþætting",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Varphænur", value: "Layers", id: "layers" },
  { label: "Fjölmiðlar", value: "Media", id: "media" },
  {
    label: "Mjólkursamvinnufélag/Kaupandi",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Blandaður/Annar framleiðandi",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Næringarefnabirgir",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Pökkuðaraðili/Vinnsluaðili",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Gæludýraverslun",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Apótek", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Alifuglsræktandi",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Alifuglasamþættari",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  {
    label: "Sauðfjárframleiðandi",
    value: "Sheep Producer",
    id: "sheep_producer",
  },
  {
    label: "Geymslustöð",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Fégarður/Söluskemma",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Svínaframleiðandi", value: "Swine Producer", id: "swine_producer" },
  { label: "Kalkúnar", value: "Turkeys", id: "turkeys" },
  {
    label: "Háskóli / Menntun",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Dýralækningastofa",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Heildsali / Smásali",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Ullarkaupandi", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Skylda",
    },
  },
  salutation: {
    label: "Ávarps",
    placeholder: "Veldu ávarps",
    errors: {
      required: "Ávarps er nauðsynlegt",
      invalid: "Vinsamlegast veldu gilt ávarps",
    },
  },
  firstName: {
    label: "Fornafn",
    placeholder: "Jón",
    errors: {
      authenticatedNameUpdateTrial:
        "Þú ert skráð/ur inn og getur ekki breytt nafninu þínu.",
      required: "Fornafn er nauðsynlegt",
      minLength: "Fornafn verður að vera að minnsta kosti 2 stafir",
      maxLength: "Fornafn má að hámarki vera 50 stafir",
    },
  },
  lastName: {
    label: "Eftirnafn",
    placeholder: "Jónsson",
    errors: {
      authenticatedNameUpdateTrial:
        "Þú ert skráð/ur inn og getur ekki breytt nafninu þínu.",
      required: "Eftirnafn er nauðsynlegt",
      minLength: "Eftirnafn verður að vera að minnsta kosti 2 stafir",
      maxLength: "Eftirnafn má að hámarki vera 50 stafir",
    },
  },
  email: {
    label: "Tölvupóstur",
    placeholder: "jon.jonsson@example.org",
    description:
      "Vinsamlegast sláðu inn tölvupóstfang sem er persónulegt fyrir þig, ekki sameiginlegt tölvupóstfang.",
    prefixWarningTitle: "Sameiginlegur pósthólf greindur",
    prefixWarningDescription:
      "Við mælum með að nota persónulegt tölvupóstfang fyrir betri persónulega upplifun",
    errors: {
      authenticatedEmailUpdateTrial:
        "Þú ert skráð/ur inn og getur ekki breytt netfanginu þínu.",
      required: "Tölvupóstur er nauðsynlegur",
      invalidEmail: "Vinsamlegast sláðu inn gilt tölvupóstfang",
      emailAssociatedWithYourAccount:
        "Tölvupóstfangið þitt er tengt reikningnum þínum og er ekki hægt að breyta því.",
    },
  },
  confirmEmail: {
    label: "Staðfesta tölvupóst",
    placeholder: "jon.jonsson@example.org",
    errors: {
      authenticatedEmailUpdateTrial:
        "Þú ert skráð/ur inn og getur ekki breytt netfanginu þínu.",
      required: "Staðfesting tölvupósts er nauðsynleg",
      invalidEmail: "Vinsamlegast sláðu inn gilt tölvupóstfang",
      emailMatchError: "Tölvupóstföng passa ekki saman",
    },
  },
  password: {
    label: "Lykilorð",
    placeholder: "Sláðu inn lykilorðið þitt",
    errors: {
      required: "Lykilorð er nauðsynlegt",
    },
  },
  confirmPassword: {
    label: "Staðfesta lykilorð",
    placeholder: "Staðfestu lykilorðið þitt",
    errors: {
      required: "Staðfesting lykilorðs er nauðsynleg",
      passwordMatchError: "Lykilorð passa ekki saman",
    },
  },
  addressLine1: {
    label: "Heimilisfang 1",
    placeholder: "Laugavegur 123",
    errors: {
      required: "Heimilisfang 1 er nauðsynlegt",
      minLength: "Heimilisfang 1 verður að vera að minnsta kosti 5 stafir",
      maxLength: "Heimilisfang 1 má að hámarki vera 100 stafir",
    },
  },
  addressLine2: {
    label: "Heimilisfang 2",
    placeholder: "Íbúð 4B",
    errors: {
      required: "Heimilisfang 2 er nauðsynlegt",
      maxLength: "Heimilisfang 2 má að hámarki vera 100 stafir",
    },
  },
  city: {
    label: "Borg / Bær",
    placeholder: "Reykjavík",
    errors: {
      required: "Borg / Bær er nauðsynleg",
      minLength: "Borg / Bær verður að vera að minnsta kosti 2 stafir",
      maxLength: "Borg / Bær má að hámarki vera 50 stafir",
    },
  },
  country: {
    label: "Land",
    placeholder: "Veldu land",
    errors: {
      required: "Land er nauðsynlegt",
      invalid: "Vinsamlegast veldu gilt land",
    },
  },
  state: {
    label: "Ríki",
    placeholder: "Veldu ríki",
    errors: {
      required: "Ríki er nauðsynlegt",
      invalid: "Vinsamlegast veldu gilt ríki",
    },
  },
  jurisdiction: {
    label: "Lögsaga leyfis",
    placeholder: "Veldu lögsögu leyfis",
    errors: {
      required: "Lögsaga leyfis er nauðsynleg",
      invalid: "Vinsamlegast veldu gilda lögsögu",
    },
  },
  zipCode: {
    label: "Póstnúmer",
    placeholder: "101",
    errors: {
      required: "Póstnúmer er nauðsynlegt",
      invalid: "Vinsamlegast sláðu inn gilt póstnúmer",
    },
  },
  role: {
    label: "Hlutverk",
    placeholder: "Veldu hlutverk þitt",
    errors: {
      required: "Vinsamlegast veldu hlutverk þitt",
      invalid: "Vinsamlegast veldu gilt hlutverk",
    },
  },
  businessType: {
    label: "Tegund fyrirtækis",
    placeholder: "Veldu tegund fyrirtækis",
    errors: {
      required: "Tegund fyrirtækis er nauðsynleg",
      invalid: "Vinsamlegast veldu gilda tegund fyrirtækis",
    },
  },
  businessName: {
    label: "Nafn fyrirtækis",
    placeholder: "Sláðu inn nafn fyrirtækis",
    errors: {
      required: "Nafn fyrirtækis er nauðsynlegt",
      minLength: "Nafn fyrirtækis verður að vera að minnsta kosti 2 stafir",
      maxLength: "Nafn fyrirtækis má að hámarki vera 100 stafir",
    },
  },
  businessSearch: {
    label: "Fyrirtækjaleit:",
    addNewAccount: "Bæta við nýjum fyrirtækjareikningi",
    canNotFindBusiness: "Finnurðu ekki fyrirtæki þítt?",
    guideline:
      "Vinsamlegast sláðu inn póstnúmer þitt, veldu síðan af listanum hér að neðan.",
    guidelineForNameSearch:
      "Vinsamlegast sláðu inn fullt nafn fyrirtækis, veldu síðan af listanum.",
    placeholder: "Hvar vinnurðu?",
    noResults: "Engar niðurstöður fundust",
    searching: "Leita...",
    selectedBusinessHeading: "Valið fyrirtæki:",
    selectedBusinessNotCorrect: "Ekki rétt?",
    selectedBusinessTryAgain: "Reyna aftur",
    selectedBusinessDismiss: "Hafna fyrirtæki",
    resultsFound: {
      singular: "1 fyrirtæki fannst",
      plural: "Mörg fyrirtæki fundust",
    },
    errors: {
      network:
        "Vandi er við að tengjast Fyrirtækjaskoraleitinni. Vinsamlegast reyndu aftur siðar.",
    },
  },
  explicitConsent: {
    label:
      "Með því að haka við þennan reit sambýst ég nota da skilmálum Elanco, viðurkennir að Elanco mun safna og vinna persónuupplýsingar mínar í samræmi við Personu verndar tilkynningu Elanco",
    errors: {
      required: "Sambýsli tölvupósts er nauðsynlegt",
    },
  },
  explicitSmsConsent: {
    label:
      "Með því að haka við þennan reit samþykki ég að fá markaðsefni frá Elanco með SMS/textaskilaboðum.",
    errors: {
      required: "Samþykki fyrir SMS er nauðsynlegt",
    },
  },
  telephone: {
    label: "Persónulegur sími",
    placeholder: "Sláðu inn persónulegan síma þinn",
    dialCodeLabel: "Kóði",
    dialCodePlaceholder: "Leita að landi...",
    errors: {
      invalid: "Vinsamlegast sláðu inn gilt símanúmer.",
    },
  },
  businessTelephone: {
    label: "Fyrirtækjassími",
    placeholder: "Sláðu inn fyrirtækjassíma þinn",
    dialCodeLabel: "Kóði",
    dialCodePlaceholder: "Leita að landi...",
    errors: {
      invalid: "Vinsamlegast sláðu inn gilt símanúmer.",
    },
  },
  professionalNumber: {
    label: "Fagmanna númer",
    placeholder: "1234567",
    errors: {
      required: "Vinsamlegast sláðu inn fagmanna númer",
      maxLength: "Inntaksmarka fari fram újór stafamörgum",
    },
  },
  addressSearch: {
    errors: {
      required: "Þessi reitur er nauðsynlegur",
    },
  },
  businessSearchField: {
    errors: {
      required: "Þessi reitur er nauðsynlegur",
    },
  },
  checkbox: {
    errors: {
      required: "Þessi reitur er nauðsynlegur",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Þessi reitur er nauðsynlegur",
    },
  },
  combobox: {
    errors: {
      required: "Þessi reitur er nauðsynlegur",
    },
  },
  datePicker: {
    errors: {
      required: "Þessi reitur er nauðsynlegur",
    },
  },
  dateRange: {
    errors: {
      required: "Þessi reitur er nauðsynlegur",
    },
  },
  dateTime: {
    errors: {
      required: "Þessi reitur er nauðsynlegur",
    },
  },
  emailField: {
    errors: {
      required: "Þessi reitur er nauðsynlegur",
    },
  },
  fileInput: {
    errors: {
      required: "Vinsamlegast veldu skrá",
    },
  },
  number: {
    errors: {
      required: "Vinsamlegast sláðu inn tölu",
      minValue: "Vinsamlegast sláðu inn gildi hærra en lágmarkið",
      maxValue: "Vinsamlegast sláðu inn gildi lægra en hámarkið",
    },
  },
  passwordField: {
    errors: {
      required: "Þessi reitur er nauðsynlegur",
    },
  },
  rangeSlider: {
    errors: {
      required: "Þessi reitur er nauðsynlegur",
    },
  },
  select: {
    errors: {
      required: "Þessi reitur er nauðsynlegur",
    },
  },
  telephoneField: {
    errors: {
      required: "Vinsamlegast sláðu aðeins inn tölustafi",
      invalidTelephone: "Vinsamlegast sláðu inn gilt símanúmer",
      invalidFormat: "Ógilt númeraform",
    },
  },
  text: {
    errors: {
      required:
        "Vinsamlegast notaðu aðeins bókstafi (A-Ö), tölustafi (0-9), og engin tákn",
      maxLength: "Innsláttarmörk fara fram úr stafamörkum",
      minLength: "Innslátt verður að vera að minnsta kosti 2 stafir",
    },
  },
  textarea: {
    characters: "stafir",
  },
  time: {
    errors: {
      required: "Þessi reitur er nauðsynlegur",
    },
  },
  form: {
    errors: {
      generic:
        "Villa kom upp við að senda eyðublaðið þitt. Vinsamlegast reyndu aftur.",
      reportAnIssue: "Vinsamlegast tilkynntu vandamál.",
      configuration: "Stillingar villa",
      noFormQuestionsAvailable: "Engar spurningar í eyðublaði tiltækar.",
      formComponentLoad:
        "Eyðublaðsþáttur gat ekki hlaðist, vegna óstuddrar reits.",
      code: "Kóði",
      type: "Tegund",
      missingRequiredFields:
        "Þessi eyðublað vantar nauðsynlega reiti (Tölvupóstur og/eða samþykki). Vinsamlegast hafðu samband við stjórnanda til að laga stillingar eyðublaðsins.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Fræðimaður", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Dýravelferð - Annað",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Dýravelferð - Verslunarstarfsfólk",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Dýravelferð - Dýralæknir",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Dýravelferð - Dýralækningahjúkrunarfræðingur",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Dýravelferð - Sjálfboðaliði",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Nautakjöt / Fóðrunargarður útvíkkun",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Nautakjötsframleiðandi",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Ræktandi", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Fyrirtækisstjórnandi / Móttökuritari",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Fyrirtækjaeigandi / Félagi",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Ráðgjafarnæringarfræðingur",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Starfsmaður fyrirtækis (ekki á sjúkrahúsi)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Mjólkurframleiðandi",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Dreifingaraðili", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Dreifingarfulltrúi, á vettvangi",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Dreifingarfulltrúi, innanhúss",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Menntastofnun - Framhaldsskólanemi",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Menntastofnun - TAFE nemi",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Menntastofnun - Háskólanemi",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Gæludýraklippari", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Læknastöðvarstjóri",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Næring / Fóðursala",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Næringarfagmaður",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Næringarfræðingur", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Skrifstofu / Starfsstjóri",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "Lausasölulyfjaverslun", id: "otc_retailer" },
  { value: "Pharmacist", label: "Lyfjafræðingur", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Apótek - Starfsfólk",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Svínaframleiðandi", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Alifuglaframleiðandi",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Starfseigandi, ekki DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Móttökuritari / Þjónustuver",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Endursöluverslun - Starfsfólk",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Framleiðandi - Blandað/Annað",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Smásali",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Sauðfjárbóndi",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Nemi RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Dýralæknir",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Þjálfari", id: "trainer" },
  { value: "Veterinarian", label: "Dýralæknir", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Dýralæknir, Starfseigandi",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Dýralækningaaðstoðarmaður",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Dýralækningahjúkrunarfræðingur",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Dýralækningastofa - Annað",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Dýralækningastofa - Dýralæknir",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Dýralækningastofa - Dýralækningahjúkrunarfræðingur",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Dýralæknasérfræðingur",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Dýralæknanemi",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Dýraskurðlæknir",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Dýralækningatæknimaður",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Heildsali", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Hr.",
    value: "M.",
    id: "m",
  },
  {
    label: "Ungfrú",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Hr.",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Frú",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Frk.",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Prófessor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
